<div class="single-plan-table__accordion">
  <app-accordion [panels]="getAccordionContent()">
    <ng-template #accordionHeaderTemplate>
      <h4 class="single-plan-table__accordion-title">
        {{ singlePlanTable.title }}
      </h4>
      <div class="single-plan-table__accordion-headers">
        <p class="single-plan-table__accordion-first-column">
          {{ singlePlanTable.subheading1 }}
        </p>
        <p class="single-plan-table__accordion-second-column">
          {{
            singlePlanTable.subheading2
              | appInterpolate: { warrantyInMonths: warrantyInMonths() }
          }}
        </p>
        <p class="single-plan-table__accordion-appliance-care">
          {{ singlePlanTable.subheading3 }}
        </p>
      </div>
    </ng-template>
    <ng-template
      #accordionPanelHeaderTemplate
      let-expanded="expanded"
      let-panel="panel"
    >
      <div class="single-plan-table__accordion-panel-header-container">
        <span
          [class]="{
            'single-plan-table__accordion-header--expanded': expanded,
          }"
          class="single-plan-table__accordion-panel-header single-plan-table__accordion-first-column pr-1"
        >
          <app-icon
            [family]="'solid'"
            [name]="'chevron-down'"
            [size]="'sm'"
            class="single-plan-table__accordion-panel-header-icon mx-2"
          />
          <p class="single-plan-table__accordion-panel-header-title">
            {{ panel.title }}
          </p>
        </span>
        <span class="single-plan-table__accordion-panel-guarantee-column">
          @switch (panel.guaranteeType) {
            @case ("breakdown-only") {
              <p>{{ singlePlanTable.breakdowns }}</p>
            }
            @case ("excluded") {
              <app-icon [family]="'light'" [name]="'circle-xmark'" />
            }
            @default {
              <app-icon
                [family]="'solid'"
                [name]="'circle-check'"
                class="single-plan-table__accordion-check-icon"
              />
            }
          }
        </span>
        <span class="single-plan-table__accordion-panel-protection-column">
          <app-icon
            [family]="'solid'"
            [name]="'circle-check'"
            class="single-plan-table__accordion-check-icon"
          />
        </span>
      </div>
    </ng-template>
    <ng-template
      #accordionPanelContentTemplate
      class="single-plan-table__accordion-panel-content"
      let-panel="panel"
    >
      {{
        panel.body | appInterpolate: { warrantyInMonths: warrantyInMonths() }
      }}
    </ng-template>
  </app-accordion>
</div>
@if (hasFreeMonths()) {
  <div class="single-plan-table__promo-panel-container">
    <div class="single-plan-table__promo-panel">
      <app-icon
        [name]="'gift'"
        [size]="'xl'"
        class="single-plan-table__promo-panel-badge--mobile px-1"
      />

      <p class="single-plan-table__promo-panel-heading">
        <app-icon
          [name]="'gift'"
          [size]="'sm'"
          class="single-plan-table__promo-panel-badge--desktop px-1"
        />
        {{ "SINGLE_PLAN_SALE_PAGE_2MF_PROMO_TABLE_BANNER" | translate }}
      </p>
    </div>
  </div>
}
